"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoversHelper = void 0;
var services_1 = require("@falcon/services");
var commonFunctions_1 = require("./commonFunctions");
var React = require("react");
var CoversHelper = /** @class */ (function () {
    function CoversHelper() {
    }
    CoversHelper.notInExcludedList = function (amountCode) {
        return !this.limitsCodesForExclude.some(function (excludedAmountCode) { return excludedAmountCode === amountCode; });
    };
    CoversHelper.getProfessionalRemovalDiv = function () {
        return React.createElement('div', { key: 'PROFESSIONAL_REMOVAL' }, "Professional Removal Limit : Up to 14 days");
    };
    CoversHelper.getAmountWording = function (coverTier, limitCode, limitAmount) {
        return coverTier === services_1.GOLD_TIER && this.unlimitedAmountCodes.includes(limitCode)
            ? ": Unlimited"
            : ": " + (0, commonFunctions_1.getAmountToDisplay)(limitAmount);
    };
    CoversHelper.limitRegex = /LIMIT/;
    CoversHelper.homeLimitTypes = {
        MONEY_LIMIT: "Money Limit",
        CREDIT_CARDS_LIMIT: "Credit Cards Limit",
        LOSS_OF_KEYS_LIMIT: "Loss of Keys Limit",
        FATAL_INJURY_LIMIT: "Fatal Injury Limit",
        TITLE_DEEDS_LIMIT: "Title Deeds Limit",
        PUBLIC_LIABILITY_LIMIT: "Public Liability Limit",
        CONTENTS_AWAY_FROM_HOME_LIMIT: "Contents Away From The Home Limit",
        MATCHING_SETS_SUITES_LIMIT: "Matching Sets & Suites Limit",
        CONTENTS_IN_GARDEN_LIMIT: "Contents in the Garden Limit",
        FREEZER_CONTENTS_LIMIT: "Freezer Contents Limit",
        DOWNLOADED_INFORMATION_LIMIT: "Downloaded Information Limit",
        STUDENT_CONTENTS_LIMIT: "Student Contents Away From the Home Limit",
        VISITOR_EFFECTS_LIMIT: "Visitor Effects Limit",
        NURSING_HOME_CONTENTS_LIMITS: "Contents in a Nursing Home Limit",
        GARDEN_PLANTS_LIMIT: "Plants in the Garden Limit",
        VALUABLES_IN_HOME_LIMIT: "Valuables in the Home Limit",
        VALUABLE_SINGLE_ARTICLE_LIMIT: "Valuable Single Article Limit",
        ALTERNATIVE_ACCOMMODATION_LIMIT: "Alternative Accommodation Limit",
        CONTENTS_LIMIT: "Contents Cover Limit",
        BUILDINGS_LIMIT: "Buildings Cover Limit",
        TRACE_AND_ACCESS_INSIDE: "Trace and access - Inside",
        TRACE_AND_ACCESS_OUTSIDE: "Trace and access - Outside",
        THEFT_FROM_OUTBUILDING: "Theft from Outbuilding",
        TENANTS_COVER: "Tenant's Cover",
        DOMESTIC_EMPLOYEES_LIABILITY_LIMIT: "Liability to domestic employees",
        OFFICE_AT_HOME_LIMIT: "Business Equipment Limit",
        CONTENTS_IN_OUTBUILDINGS_LIMIT: "Contents in Outbuildings Limit",
        ALTERNATIVE_ACCOMMODATION_CONTENT_LIMIT: "Alternative Accommodation Content Limit"
    };
    CoversHelper.limitsCodesForExclude = [
        "PERSONAL_LIABILITY_LIMIT"
    ];
    CoversHelper.unlimitedAmountCodes = [
        "DOWNLOADED_INFORMATION_LIMIT"
    ];
    return CoversHelper;
}());
exports.CoversHelper = CoversHelper;
//# sourceMappingURL=CoversHelper.js.map